import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { format } from 'date-fns';
import fr from 'date-fns/locale/fr';

const AdminRendezVous = () => {
  const [rdvs, setRdvs] = useState([]);
  const [filteredRdvs, setFilteredRdvs] = useState([]);
  const [statusFilter, setStatusFilter] = useState('all');
  const [patientSearch, setPatientSearch] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchRdvs = async () => {
      try {
        const res = await axios.get('https://1irywxa5c3.execute-api.ca-central-1.amazonaws.com/prod/admin/appointments');
        setRdvs(res.data);
        setFilteredRdvs(res.data);
      } catch (err) {
        console.error('Erreur récupération rendez-vous :', err);
        setError("Erreur lors du chargement des rendez-vous.");
      } finally {
        setLoading(false);
      }
    };
    fetchRdvs();
  }, []);

  useEffect(() => {
    const filtered = rdvs.filter((r) => {
      const statusOk = statusFilter === 'all' || r.status === statusFilter;
      const patientOk = r.patient_name?.toLowerCase().includes(patientSearch.toLowerCase());
      return statusOk && patientOk;
    });
    setFilteredRdvs(filtered);
  }, [statusFilter, patientSearch, rdvs]);

  return (
    <div style={{ padding: '20px' }}>
      <h2>📅 Tous les rendez-vous</h2>

      {loading ? (
        <p>Chargement...</p>
      ) : error ? (
        <p style={{ color: 'red' }}>{error}</p>
      ) : (
        <>
          <div style={{ marginBottom: '15px', display: 'flex', gap: '20px', alignItems: 'center' }}>
            <label>
              Filtrer par statut :
              <select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)} style={{ marginLeft: '8px' }}>
                <option value="all">Tous</option>
                <option value="scheduled">Scheduled</option>
                <option value="cancelled">Cancelled</option>
                <option value="completed">Completed</option>
              </select>
            </label>

            <label>
              Recherche patient :
              <input
                type="text"
                value={patientSearch}
                onChange={(e) => setPatientSearch(e.target.value)}
                placeholder="Nom du patient"
                style={{ marginLeft: '8px' }}
              />
            </label>
          </div>

          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                <th style={thStyle}>Date</th>
                <th style={thStyle}>Heure</th>
                <th style={thStyle}>Service</th>
                <th style={thStyle}>Patient</th>
                <th style={thStyle}>Professionnel</th>
                <th style={thStyle}>Statut</th>
              </tr>
            </thead>
            <tbody>
              {filteredRdvs.map((r) => (
                <tr key={r.appointment_id} style={{ borderBottom: '1px solid #ddd' }}>
                  <td style={tdStyle}>
                    {r.start_time ? format(new Date(r.start_time), "dd MMMM yyyy", { locale: fr }) : ''}
                  </td>
                  <td style={tdStyle}>
                    {r.start_time ? format(new Date(r.start_time), "HH:mm", { locale: fr }) : ''}
                  </td>
                  <td style={tdStyle}>{r.service_name || '—'}</td>
                  <td style={tdStyle}>{r.patient_name}</td>
                  <td style={tdStyle}>{r.professional_name}</td>
                  <td style={{
                    ...tdStyle,
                    color: r.status === 'cancelled' ? 'red' : r.status === 'scheduled' ? 'green' : 'black',
                    fontWeight: 'bold'
                  }}>
                    {r.status}
                  </td>
                </tr>
              ))}
              {filteredRdvs.length === 0 && (
                <tr>
                  <td colSpan="6" style={{ textAlign: 'center', padding: '12px', fontStyle: 'italic' }}>
                    Aucun rendez-vous trouvé.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </>
      )}
    </div>
  );
};

const thStyle = {
  textAlign: 'left',
  padding: '8px',
  backgroundColor: '#f0f0f0',
  borderBottom: '2px solid #ccc',
};

const tdStyle = {
  padding: '8px',
};

export default AdminRendezVous;